module.exports = __webpack_public_path__ + "img/perfectPutter1.06d4fbc8.png";